export default __webpack_public_path__ + "static/media/bullseye.8f3eb67a.svg";